export default __webpack_public_path__ + "fonts/reason-img3.svg";